export default __webpack_public_path__ + "static/caption-03-jp-4313f8227dc26da08bd0ef322c27d82f.webp";